// Vendors
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const BACKGROUND_MODAL_FOOTER_STAY_BUTTON_PROPS = {
    size: VARIANTS.ButtonSizeType.LARGE,
    type: VARIANTS.ButtonVariantType.PRIMARY,
  },
  BACKGROUND_MODAL_FOOTER_DECLINE_BUTTON_PROPS = {
    size: VARIANTS.ButtonSizeType.LARGE,
    type: VARIANTS.ButtonVariantType.SECONDARY,
  },
  BACKGROUND_MODAL_FOOTER_PROPS = {
    variant: VARIANTS.FooterVariantsType.ACTION_BUTTONS,
  };

export {
  BACKGROUND_MODAL_FOOTER_PROPS,
  BACKGROUND_MODAL_FOOTER_DECLINE_BUTTON_PROPS,
  BACKGROUND_MODAL_FOOTER_STAY_BUTTON_PROPS,
};
